<template>
  <v-container>
    <div class="d-flex justify-end">
      <v-breadcrumbs :items="breadItems" divider=">"></v-breadcrumbs>
    </div>
    <v-row>
      <v-col sm="12" md="4" lg="3">
        <v-card min-height="350px" class="border-radius-10">

          <v-row>
            <v-col cols="12">
              <div class="student-profile">
                <div class="student-profile__avatar">
                  <v-img src="../../../assets/profile-photo.png" class="student-profile__photo"></v-img>
                </div>
              </div>

              <div class="student-info">
                <div class="student-info__name">{{ object.std_fname }} {{ object.std_lname }}</div>
                <div class="student-info__email">{{ object.gaurdian_email }}</div>
                <div class="student-info__phone">{{ object.gaurdian_contactno }}</div>
              </div>


              <div class="student-class" v-if="user.user_role == 'Admin'">
                <div class="student-class__info">
                  <div class="student-class__info-title"></div>
                  <div class="student-class__info-value">
                    <v-switch color="green" v-model="switch1"></v-switch>

                  </div>
                </div>

                <div class="student-class__info">
                  <div class="student-class__info-title">Enquiry Date</div>
                  <div class="student-class__info-value">{{ object.creation_time }}</div>
                </div>

                <div class="student-class__info">
                  <div class="student-class__info-title">Class</div>
                  <div class="student-class__info-value">O-Level</div>
                </div>

              </div>

            </v-col>
          </v-row>
          <div class="student-class">

            <v-row>
              <v-col>
                <h4>Siblings</h4>
                <div v-for="sibling in object.siblings">
                  <router-link class="profile-link" active-class="active" :exact="true"
                    :to="{ name: 'StudentProfile', params: { id: sibling.std_id } }">
                    <p>{{ sibling.std_fname }} {{ sibling.std_lname }}</p>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col sm="12" md="8" lg="9">
        <v-card min-height="100%" class="border-radius-10" style="padding: 12px;">
          <v-row style="float: right;">
            <v-col>
              <v-btn color="success" class="profile-button" @click="showDialog(object)" small>
                Add Details
              </v-btn>

              <!-- <v-btn class="profile-button" v-if="object.user_id == '0'" color="success"  @click="showDialog2(object)" small>
                    Set Username
                </v-btn> -->
            </v-col>
          </v-row>
          <div style="clear:both"></div>
          <!-- class="box-style" -->
          <v-row>
            <v-col md="6">
              <div class="tutor-details border-right">
                <h2 class="tutor-details__heading">About Student</h2>
                <v-simple-table class="tutor-details__table" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th class="item-name">Full Name</th>
                        <td class="item-value text-right">{{ object.std_fname }} {{ object.std_lname }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Username</th>
                        <td class="item-value text-right">{{ object.std_username }}
                        </td>
                      </tr>
                      <!-- <tr>
                                            <th class="item-name">Email</th>
                                            <td class="item-value text-right">{{ object.std_email }}
                                            </td>
                                        </tr> -->
                      <tr>
                        <th class="item-name">Gender</th>
                        <td class="item-value text-right">{{ object.std_gender }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Tuition Type</th>
                        <td class="item-value text-right">{{ object.std_tuition_type }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>

            <v-col md="6">
              <div class="tutor-details">
                <h2 class="tutor-details__heading">Guardian Details</h2>
                <v-simple-table class="tutor-details__table" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th class="item-name">Guardian Name</th>
                        <td class="item-value text-right">{{ object.gaurdian_fname }} {{ object.gaurdian_lname }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Guardian Email</th>
                        <td class="item-value text-right">{{ object.gaurdian_email }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Guardian Contact No</th>
                        <td class="item-value text-right">{{ object.gaurdian_contactno }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>

          <!-- <v-row class="box-style">
                        <v-col md="12">
                            <div class="tutor-details">
                                <h2 class="tutor-details__heading">Bank Details</h2>
                                <v-simple-table class="tutor-details__table bank" dense>
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th>Bank Name</th>
                                            <th>Account Title</th>
                                            <th>Account Number</th>
                                            <th>Sort Code</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>
                                                {{object.tutor_bankname}}
                                            </td>
                                            <td>
                                                {{object.tutor_account_title}}
                                            </td>
                                            <td>
                                                {{object.tutor_accountno}}
                                            </td>
                                            <td>
                                                {{object.tutor_sortcode}}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </div>
                        </v-col>
                    </v-row> -->

          <!-- <v-row>
                        <v-col md="6">
                            <div class="lecture-detail">
                                <h3 class="lecture-detail__title">Delivered</h3>
                                <div class="lecture-detail__box">
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value">34</div>
                                        <div class="lecture-detail__name">Total Lectures</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value">25 hr</div>
                                        <div class="lecture-detail__name">Total Time</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value">£ 300</div>
                                        <div class="lecture-detail__name">Paid Amount</div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col md="6">
                            <div class="lecture-detail">
                                <h3 class="lecture-detail__title">Remaining</h3>
                                <div class="lecture-detail__box remaining">
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value remaining">25</div>
                                        <div class="lecture-detail__name">Total Lectures</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value remaining">20 hr</div>
                                        <div class="lecture-detail__name">Total Time</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value remaining">£ 250</div>
                                        <div class="lecture-detail__name">Unpaid Amount</div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row> -->
          <hr>
          <v-row>
            <v-col>
              <h2>Week Wise Hours</h2>
              <table style="width:100%;border:1px solid lightgrey" v-if="object.week_hours">
                <tr>
                  <th>Mon</th>
                  <th>Tue</th>
                  <th>Wed</th>
                  <th>Thu</th>
                  <th>Fri</th>
                  <th>Sat</th>
                  <th>Sun</th>
                </tr>
                <tr style="text-align: center">
                  <td>{{ object.week_hours.mon }}</td>
                  <td>{{ object.week_hours.tue }}</td>
                  <td>{{ object.week_hours.wed }}</td>
                  <td>{{ object.week_hours.thu }}</td>
                  <td>{{ object.week_hours.fri }}</td>
                  <td>{{ object.week_hours.sat }}</td>
                  <td>{{ object.week_hours.sun }}</td>
                </tr>
              </table>
            </v-col>
          </v-row>
          <v-row class="profile_rows">
            <v-col>
              <h2 style="float:left">Notes</h2>
              <v-btn small color="primary" style="float:right" @click="addNotesDialog">Add Notes</v-btn>
              <div style="clear:both;"></div>
              <div class="row" v-for="note in object.notes">
                <div class="col-md-2">
                  <!-- <img src="../../../assets/profile-photo.png"  class="img img-rounded img-fluid"/> -->
                  <v-img src="../../../assets/profile-photo.png" class="student-profile__photo"
                    style="border-radius:50%" height="70" width="70"></v-img>
                  <p>{{ note.created_at }}</p>
                  <!-- <p class="text-secondary text-center"></p> -->
                </div>
                <div class="col-md-10">
                  <p>
                  <div style="float: right">
                    <v-icon @click="editNotes(note)" color="success">mdi-pencil-box</v-icon>
                    <v-icon color="red" @click="deleteNotes(note)">mdi-delete</v-icon>

                  </div>
                  <strong>{{ note.reviewer.name }}</strong>
                  <!-- <span class="float-right"><i class="text-warning fa fa-star"></i></span>
                        <span class="float-right"><i class="text-warning fa fa-star"></i></span>
        	            <span class="float-right"><i class="text-warning fa fa-star"></i></span>
        	            <span class="float-right"><i class="text-warning fa fa-star"></i></span> -->

                  </p>
                  <p>{{ note.notes }}</p>


                  <!-- <p>
        	            <a class="float-right btn btn-outline-primary ml-2"> <i class="fa fa-reply"></i> Reply</a>
        	            <a class="float-right btn text-white btn-danger"> <i class="fa fa-heart"></i> Like</a>
        	       </p> -->
                </div>
              </div>
            </v-col>

          </v-row>
        </v-card>

      </v-col>
    </v-row>
    <v-dialog v-model="notes_dialog" persistent max-width="600px">
      <!-- <template v-slot:activator="{ on, attrs2 }">
          
          <v-btn color="#6A158E" dark  v-bind="attrs2"
          v-on="on">+ Add Session</v-btn>
        </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">Add Notes</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-row>

              <v-col>
                <label class="custom-label">Notes</label>

                <v-textarea v-model="data.notes" :error-messages="errors.notes" label="Notes" placeholder="Notes" solo>
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="notes_dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="addNote">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog2" persistent max-width="600px">
      <!-- <template v-slot:activator="{ on, attrs2 }">
          
          <v-btn color="#6A158E" dark  v-bind="attrs2"
          v-on="on">+ Add Session</v-btn>
        </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">Set Username</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-row>

              <v-col>
                <label class="custom-label">Username</label>

                <v-text-field v-model="data.username" :error-messages="errors.username" label="Username"
                  placeholder="Username" solo></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog2 = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="setUsername">Send Email</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <!-- <template v-slot:activator="{ on, attrs2 }">
          
          <v-btn color="#6A158E" dark  v-bind="attrs2"
          v-on="on">+ Add Session</v-btn>
        </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">Add Class</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-select v-model="data.selected_class" :items="classes" hide-selected label="Select Class" small-chips
                  item-value="class_id" item-text="class_name">
                </v-select>
              </v-col>
            </v-row>




          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="chooseCLass">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "Profile",
  components: {},
  data() {
    return {
      data: {
        'student_id': this.$route.params.id,
        'user_id': JSON.parse(localStorage.getItem("user")).id,
        'notes': '',
      },
      errors: {},
      notes_dialog: false,
      dialog: false,
      dialog2: false,
      user: JSON.parse(localStorage.getItem("user")),

      switch1: true,
      object: {},
      classes: [],
      menu1: false,
      menu2: false,
      menu3: false,
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard"
          }
        },
        {
          text: "Students",
          disabled: true,
          to: {
            name: "Students"
          }
        },
        {
          text: "Profile",
          disabled: true,
          to: {
            name: "StudentProfile"
          }
        }
      ]
    };
  },
  methods: {
    deleteNotes(item) {
      // console.log(item)
      this.data.notes_id = item.id;
      Swal2.fire({
        title: 'Are you sure to delete this note?',
        // text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        // console.log(resu)
        if (result.isConfirmed) {

          axios.post("delete/student/notes", this.data)
            .then((response) => {
              console.log(response)
              // this.formalizeTable(response.data);
              // this.notes_dialog = false;
              // this.data.notes = ''
              // this.data.delete_notes = 0;
              this.getDetails()
              // console.log(response)
              // this.classes = response.data.response
            });
        }
      })
    },
    addNotesDialog() {
      this.data.notes_id = 0;
      this.notes_dialog = true
    },
    editNotes(item) {
      this.notes_dialog = true;
      this.data.notes_id = item.id;
      console.log(item)
      this.data.notes = item.notes
    },
    setUsername() {
      let form = new Form({ ...this.data })
      this.overlay = true
      form.post("set/username")
        .then((response) => {
          console.log(response)
          // this.formalizeTable(response.data);
          this.dialog2 = false;
          this.getDetails()
          this.overlay = false

          // console.log(response)
          // this.classes = response.data.response
        })
        .catch(response => {
          this.overlay = false

          console.log(response)
          if (response.status === 400) {
            this.errors = response.data
          }
          // alert(response.status)
          if (response.status === 422) {
            //    console.log(response.data)
            this.errors = response.data.errors;
          }
          this.loading = false
        });
    },

    chooseCLass() {
      // var data = {
      //   "student_id" : this.student_id,
      //   "class_id" : this.selectedClass
      // }
      axios.post("select/class", this.data)
        .then((response) => {
          // this.formalizeTable(response.data);
          this.dialog = false;
          // this.getItems()
          this.getDetails()
          // console.log(response)
          // this.classes = response.data.response
        });
    },
    showDialog2(item) {
      this.data.student_id = item.std_id
      this.dialog2 = true;
    },
    showDialog(item) {
      // console.log(item)
      this.dialog = true
      axios.get("classes")
        .then((response) => {
          // this.formalizeTable(response.data);
          // this.loading = false;
          // console.log(response)
          this.classes = response.data.response
          this.data.student_id = item.std_id
          this.data.joining_date = item.std_joining_date
          this.data.ending_date = item.std_leaving_date
          this.data.date_of_birth = item.std_dob
          this.data.number_of_hours = item.std_no_of_hours
          this.data.selected_class = parseInt(item.class_id)
        });
    },
    addNote() {
      // this.data.notes_id = 0;
      axios.post("add/student/notes", this.data)
        .then((response) => {
          // this.formalizeTable(response.data);
          this.notes_dialog = false;
          this.data.notes = ''
          this.data.delete_notes = 0;
          this.getDetails()
          // console.log(response)
          // this.classes = response.data.response
        });
    },
    getDetails() {
      axios.get(apiRoutes.students.url + '/' + this.$route.params.id).then(response => {
        console.log(response.data)
        this.object = response.data
        this.switch1 = response.data.status
      })
    }
  },
  mounted() {
    this.getDetails()
  },
  watch: {
    switch1: function (val) {
      console.log(val);
      axios.get("student/status/update/" + this.$route.params.id + "/" + val).then(response => {
        console.log(response.data)
        this.object = response.data
      })
    },
    $route(to, from) {
      // react to route changes...
      this.getDetails();

    }
  },
};
</script>

<style lang="scss" scoped>
.v-input--selection-controls__input {
  margin: auto !important;
}

.border-radius-10 {
  border-radius: 10px;
}

.student-profile {
  height: 175px;
  margin-top: -12px;
  background: #f1efef;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  &__avatar {
    max-height: 120px;
    overflow: hidden;
    width: 120px;
    border-radius: 50%;
    border: 1px solid #6a158e;
    padding: 2px;
    margin-bottom: -20px;
  }
}

.student-info {
  margin-top: 40px;
  text-align: center;

  &__name {
    font: 500 18px/22px Gotham;
    color: #172b4d;
  }

  &__email,
  &__phone {
    font: 400 14px/22px Gotham;
    color: #3f475d99;
  }
}

.student-class {
  padding: 10px 18px;
  margin-top: 30px;
  border: 0.5px solid #d6dbe1;
  border-left: 0;
  border-right: 0;

  &__info {
    display: flex;
    justify-content: space-between;

    &-title {
      font: 500 14px/20px Gotham;
      color: #172b4d;
    }

    &-value {
      font: 300 14px/13px;
      font-family: "Gotham Narrow";
      color: #8898aa;
    }
  }
}

.student-subjects {
  padding: 10px 18px;
  margin-top: 15px;

  &__btn {
    margin-bottom: 10px;
  }
}

.profile-button {
  margin-left: 5px;
  margin-right: 5px;
}

.profile_rows {
  padding: 10px
}
</style>